import { render } from "./AddTypeContainerPage.vue?vue&type=template&id=4994fbf7&ts=true"
import script from "./AddTypeContainerPage.vue?vue&type=script&lang=ts"
export * from "./AddTypeContainerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__